import React, { Component, ReactNode } from "react";
import {
  FormControlLabel,
  Checkbox,
  WithStyles,
  withStyles,
  Grid,
  Theme,
  createStyles,
  Typography,
  ClickAwayListener,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import _ from "lodash";
import {
  CloseOutlined as CloseIcon,
  FileCopy as CopyIcon,
  Error
} from '@material-ui/icons';
import cs from 'classnames';
import { escapeRegExp } from "../course-Management/helpers/helpers";
const styles = (theme: Theme) => createStyles({
  activeOptionItem: {
    background: 'rgb(233 233 233)'
  },
  textElipse: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  grey: {
    color: '#666666'
  },
  fontSize_SM: {
    fontSize: 16,
  },
  multiCheckedCheckbox: {
    backgroundColor: '#1d7dea !important',
    border: '1px solid #1d7dea !important',
    borderRadius: 2,
    opacity: 1,
    color: '#99a1a7',
    '&::before': {
      content: "''",
      fontSize: 14,
      position: 'absolute',
      top: 1,
      left: 4,
      width: 4,
      height: 8,
      border: 'solid #fff',
      borderWidth: '0 2px 2px 0',
      transform: 'rotate(45deg)'
    },
    '&:hover': {
      backgroundColor: '#1d7dea'
    }
  },

  // optionList: {
  //   top: "100%",
  //   left:0,
  //   width: "100%",
  //   right:0,
  //   zIndex:9,
  //   position: "absolute",
  //   marginTop:15,
  //   '& .optionContainer': {
  //     '&::after': {
  //       content: '" "',
  //       position: "absolute",
  //       borderColor: "rgb(194 225 245 / 0%)",
  //       border: "solid rgb(0 0 0 / 0%)",
  //       borderBottomColor: "rgb(255 255 255)",
  //       boxShadow: "1px 1px 1px #aea8a8",
  //       transform: "rotate(226deg)",
  //       background: "rgb(255 255 255)",
  //       borderWidth:11,
  //       height:0,
  //       top:'-11px',
  //       right:18,
  //       zIndex:999,
  //     },
  //   },
  //   '& .multiSelectOptions': {
  //     background: 'rgb(255 255 255)',
  //     position: "absolute",
  //     padding: '10px 16px',
  //     zIndex:9,
  //     boxShadow: "1px 0px 4px #666",
  //     maxHeight:200,
  //     overflowY: "auto",
  //     overflowX: "hidden",
  //     top: "150%",
  //     left:0,
  //     right:0,
  //     borderRadius:4,
  //     '& .search-btn': {
  //       position: "absolute",
  //       top:20,
  //       left:18,
  //       width:20
  //     },
  //     '& input': {
  //       background: "rgb(255 255 255)",
  //       border: "0.5px solid rgb(29 125 234) !important",
  //       boxSizing: "border-box",
  //       borderRadius:4,
  //     },
  //     '& .inputDropdown': {
  //       padding: '10px 0px 10px',
  //       borderBottom: "1px solid #DFDFDF",
  //     },
  //     '& .optionItem': {
  //       padding: '8px 12px',
  //       '&:hover': {
  //         background: 'rgb(233 233 233)'
  //       }
  //     }
  //   },
  // },

  selectContainer: {
    border: "solid 1px rgb(224 224 224)",
    cursor: "pointer",
    padding: "4px 10px",
    minHeight: 36,
    maxHeight: 120,
    overflowX: "auto",
    borderRadius: 4,
    position:"relative",
    color: '#666',
    '& input': {
      width: "100%",
      outline:0,
      border:0,
      color: '#666',
      fontSize: 16,
      lineHeight: '30px',      
    },
    '& ::placeholder':{
      color: "#999",
      fontWeight: 'normal',
      fontSize:14,
      opacity: 1,
      fontFamily: '"Nunito", sans-serif',
    },
    '& .search-btn': {
      padding: "3px 8px 0px 10px",
      height:24,
      color: '#666'
    }

    // '& .singleSelectOption': {
    //   padding: "6px 8px",
    //   color: "rgb(102 102 102)",
    //   height:34,
    //   '&>:first-child': {
    //     textOverflow: 'ellipsis',
    //     overflow: 'hidden',
    //     width: '100%',
    //     whiteSpace: 'nowrap'
    //   }
    // },
    // '& .chipInput': {
    //   maxHeight: 70,
    //   overflow: "auto",
    // },
    // '& .chipContainer': {
    //   marginLeft: 36,
    //   padding: "8px 0 0px",
    // },
    // '& img': {
    //   top: 10,
    // },
    // '& input': {
    //   '&:focus': {
    //     outline: 0
    //   },
    //   width: "100%",
    //   border: "0px solid rgb(223 223 223) !important",
    //   height: '36px !important',
    //   padding: "6px 10px 6px 40px",
    //   borderRadius: 4,
    //   fontSize: 16,
    //   color: '#666'
    // },
    // '& .icon': {
    //   position: 'absolute',
    //   right: 0,
    //   top: 0,
    //   bottom: 0,
    //   padding: '6px 0px'
    // },
    // '& .optionContainer': {
    //   width: "100%",
    //   position: "absolute",
    //   top: 0,
    //   left:0,
    //   right:0,
    //   zIndex:9,
    //   '&::after': {
    //     content: '" "',
    //     position: "absolute",
    //     borderColor: "rgb(194 225 245 / 0%)",
    //     border: "solid rgb(0 0 0 / 0%)",
    //     borderBottomColor: "rgb(255 255 255)",
    //     boxShadow: "1px 1px 1px #aea8a8",
    //     transform: "rotate(226deg)",
    //     background: "rgb(255 255 255)",
    //     borderWidth:11,
    //     height:0,
    //     top:'-11px',
    //     right:18,
    //     zIndex:999,
    //   },
    // },
    // '& .multiSelectOptions': {
    //   background: 'rgb(255 255 255)',
    //   position: "absolute",
    //   padding: '10px 16px',
    //   zIndex:9,
    //   boxShadow: "1px 0px 4px #666",
    //   maxHeight:200,
    //   overflowY: "auto",
    //   overflowX: "hidden",
    //   top: "150%",
    //   left:0,
    //   right:0,
    //   borderRadius:4,
    //   '& .search-btn': {
    //     position: "absolute",
    //     top:20,
    //     left:18,
    //     width:20
    //   },
    //   '& input': {
    //     background: "rgb(255 255 255)",
    //     border: "0.5px solid rgb(29 125 234) !important",
    //     boxSizing: "border-box",
    //     borderRadius:4,
    //   },
    //   '& .inputDropdown': {
    //     padding: '10px 0px 10px',
    //     borderBottom: "1px solid #DFDFDF",
    //   },
    //   '& .optionItem': {
    //     padding: '8px 12px',
    //     '&:hover': {
    //       background: 'rgb(233 233 233)'
    //     }
    //   }
    // },
  },
  multiCheckbox: {
    padding: 0,
    top: 0,
    left: 0,
    width: 16,
    height: 16,
    '-moz-appearance': 'none',
    color: 'rgb(204, 204, 204)',
    backgroundColor: '#fff',
    border: '1px solid #979797',
    borderRadius: 2,
    marginRight: 8,
    '& svg': {
      fontSize: '1.5rem',
      fontFamily: 'Nunito',
      fill: '#979797',
      opacity: 0
    }
  },
  checkedCheckbox: {
    backgroundColor: '#1d7dea !important',
    border: '1px solid #1d7dea !important',
    borderRadius: 4,
    opacity: 1,
    color: '#99a1a7',
    '&::before': {
      content: "''",
      fontSize: 14,
      position: 'absolute',
      top: 1,
      left: 6,
      width: 4,
      height: 10,
      border: 'solid #fff',
      borderWidth: '0 2px 2px 0',
      transform: 'rotate(45deg)'
    },
    '&:hover': {
      backgroundColor: '#1d7dea'
    }
  },

  checkbox: {
    padding: 0,
    top: 0,
    left: 0,
    width: 20,
    height: 20,
    '-moz-appearance': 'none',
    color: 'rgb(204, 204, 204)',
    backgroundColor: '#fff',
    border: '1px solid #979797',
    borderRadius: 4,
    marginRight: 14,
    '& svg': {
      fontSize: '1.5rem',
      fontFamily: 'Nunito',
      fill: '#979797',
      opacity: 0
    }
  },
  primaryColor: {
    color: 'rgb(29 125 234)'
  },
  marginZero: {
    marginLeft: 0
  },
  customRadio: {
    // marginRight: '100%',
    // width: '100%',
    // '&>:nth-child(2)': {
    //   textOverflow: 'ellipsis',
    //   overflow: 'hidden',
    //   width: '100%',
    //   whiteSpace: 'nowrap'
    // }
  },
  customChip: {
    height: 23,
    margin: "0px 8px 6px 0px",
    padding: "1px 3px 3",
    background: "rgb(244 244 244)",
    lineHeight: '20px',
    borderRadius: 16,
    verticalAlign: "middle",
    display: "inline-block",
    '& .chipLabel': {
      color: '#666',
      padding: '0px 10px 0px',
      fontSize: '12px',
      fontWeight: 400,
      verticalAlign: 'bottom',
    },

    '& .chipIcon': {
      '&:hover': {
        '& svg': {
          color: '#333'
        }
      },
      '& svg': {
        color: '#666',
        cursor: 'pointer'
      }
    }
  },
    
  optionBox: {
    position: 'relative',
    top: 10,
    '&::after': {
      content: '" "',
      position: "absolute",
      borderColor: "rgb(194 225 245 / 0%)",
      border: "solid rgb(0 0 0 / 0%)",
      borderBottomColor: "rgb(255 255 255)",
      boxShadow: "1px 1px 1px #aea8a8",
      transform: "rotate(226deg)",
      background: "rgb(255 255 255)",
      borderWidth:8,
      height:0,
      top:'-6px',
      right:18,
      zIndex:999,
    },
    '& .optionContainer': {     
      '& .multiSelectOptions': {
        maxHeight: '200px'
      },
      '& .options': {
        overflow: "auto",
        maxHeight: '200px'
      },
    '& option': {
      '&:hover': {
        background: '#bcbcbc'
      }
    },
      position: "absolute",
      zIndex:10,
      background: "rgb(255 255 255)",
      maxHeight:200,
      border: "solid 1px rgb(188 188 188)",
      width: "100%",
      // overflow: "auto",
      boxShadow: "0px -1px 5px -2px #b2b2b2",
      // overflowY: "auto",
      // overflowX: "hidden",
      left:0,
      right:0,
      borderRadius:4,
      '& .optionItem': {
        padding: '6px 14px',
        '&:hover': {
          background: 'rgb(250 250 250)'
        }
      },
    }
  },
  errorText: {
    color: '#F21D1D',
    verticalAlign: 'middle',
    marginTop: '3px',
    '& svg': {
      verticalAlign: 'bottom',
      marginRight: '5px',
    }
  },
  errorBorder:{
    border: '1px solid #F21D1D',
    borderRadius: '4px',
  }

})

interface MyPATMultiSearchProps extends WithStyles<typeof styles> {
  valueAutoComp: any;
  onChange: Function;
  isMulti: any;
  optionsList?: any;
  placeholderText: string,
  values: any;
  labelKey: string,
  valueKey: string,
  options: any[],
  isSearchAble: boolean,
  customOptionIcon: ReactNode, //Work only with isCutomOptionIcon true
  isCustomOptionIcon: boolean,  //
  isDropdownSearch: boolean,
  isCustomFilter:boolean,
  filtredFunction:Function,
  name:string;
  searchSuggetionFunction: Function;
  emptyText?: string;
  error:boolean;
  errorText:string;
  disableInput:boolean;
  showAllOptionsOnFocus: boolean;
}
interface MyPATMultiSearchState extends WithStyles<typeof styles> {
 selectedOption:any, 
 activeOption: number,
 filteredOptions: any [],
 showOptions: boolean,
 userInput: string,
 multiSelectValues:any [],
 optionList:any;
 placeholder: string,
 filter: string,
 inputValue:string,
 options:any
}
export class MyPATMultiSearch extends Component<MyPATMultiSearchProps,MyPATMultiSearchState> {
  constructor(props: MyPATMultiSearchProps) {
    super(props);
    this.hideOptionsList = this.hideOptionsList.bind(this);
    this.handleShowOptions = this.handleShowOptions.bind(this);
    this.checkOptionSelected = this.checkOptionSelected.bind(this);
    this.state = {
      activeOption: 0,
      filteredOptions: this.props.showAllOptionsOnFocus ? this.props.options : [],
      showOptions: false,
      userInput: "",
      multiSelectValues: [],
      optionList: null,
      placeholder: '',
      filter: '',
      selectedOption:this.props.values,
      classes:this.props.classes,
      inputValue:!_.isEmpty(this.props.values) ?this.props.values[`${this.props.labelKey}`]:'',
      options:this.props.options
    };
    this.getFilteredOptions = _.debounce(this.getFilteredOptions,200);
  }
  
  componentDidUpdate(prevProps:MyPATMultiSearchProps,prevState:any){
    const{labelKey,valueKey}=this.props;
    if(prevProps.options!==this.props.options){
      this.setState({options:this.props.options});
    }
    if(prevProps.values!==this.props.values){
      const value=_.get(this.props.values,`${this.props.labelKey}`,"");
      this.setState({
           inputValue:value
          });
    }
  }
  handleShowOptions(event: any) {
    event.stopPropagation();
    this.setState({ showOptions: false });
  }
  closeDropDown=()=>{
    const{labelKey}=this.props;
    this.setState((prevState:MyPATMultiSearchState)=>{ 
        const{selectedOption}=prevState;
        const prevValue=_.get(selectedOption,`${labelKey}`,'');
        return {showOptions: false,inputValue:prevValue}
    });
  }
  getFilteredOptions =() =>{
    
    const {labelKey ,isCustomFilter,filtredFunction,name} = this.props;
    const{options,inputValue}=this.state;
    const lowercasedFilter = inputValue.toLowerCase();
    let filteredData=[];
   if(isCustomFilter){
     this.setState({showOptions:true},()=>{filtredFunction(lowercasedFilter,name)});
   }else{
    const { filteredOptions } = this.state;
    const regex = new RegExp(escapeRegExp(lowercasedFilter), 'i');
     filteredData = options.filter(function (datum:any) {
      return (datum[`${labelKey}`].search(regex) > -1);
    });
    this.setState({ filteredOptions: filteredData, showOptions: true});
    }
  }
  hideOptionsList() {
    this.setState({ showOptions: false });
  }

  handleOptionClick(option:any){
    const {valueKey,name,isMulti,isSearchAble,labelKey}=this.props;
      let showOptions=true;
      if(!isMulti&&isSearchAble){
        showOptions=false;
      }
      this.setState({selectedOption:option,showOptions,inputValue:option[`${labelKey}`]},()=>{this.props.onChange(option,name)});
  }
  checkOptionSelected(option:any){
       const {values}=this.props;
       if(!values) {
         return false
       }
     for(let i:any=0; i<values.length; i++){
       if(i.id==option.id){
         return true;
       }
     }
    return false; 
  }
  renderOptions() {
    const { classes, values, labelKey, valueKey, options, isSearchAble, isMulti, customOptionIcon, isCustomOptionIcon,isCustomFilter,emptyText = 'No Data found',placeholderText } = this.props;
    const tempOptions = isSearchAble && !isCustomFilter ? this.state.filteredOptions : this.state.options;
    return (
      <Grid className="options">
        {tempOptions.length === 0 && <Grid className={[classes.grey, 'optionItem'].join(' ')}>{emptyText}</Grid>}
        {tempOptions.map((option: any, index: number) => {
          return (
            <Grid key={index}
              onClick={() => { this.handleOptionClick(option)}}
              className={[this.checkOptionSelected(option) && classes.activeOptionItem, "optionItem"].join(' ')} >
              <FormControlLabel
                  className={[classes.customRadio, classes.marginZero].join(
                    " "
                  )}
                  control={
                    <>

                    {isMulti && !isCustomOptionIcon ?

                    <Checkbox
                    autoFocus
                      checked={isMulti ? values.includes(option[`${valueKey}`]) : values == option[`${valueKey}`]}
                      classes={{
                        root: classes.multiCheckbox,
                        checked: classes.multiCheckedCheckbox,
                        colorPrimary: classes.primaryColor,
                      }}
                      color="primary"
                      disableRipple
                    />
                    :
                    customOptionIcon
                    }
                    </>
                  }
                  value={option[`${valueKey}`]}
                  label={option[`${labelKey}`]}
                  classes={{
                    label: [classes.fontSize_SM, classes.grey, classes.textElipse].join(" "),
                  }} />
            </Grid>
          );
        }
        )}
      </Grid>
    )
  }

  render() {
    const { classes, options, values, valueKey, labelKey, isSearchAble,
           isMulti, isDropdownSearch,name,placeholderText,error,errorText,disableInput, showAllOptionsOnFocus } = this.props;
    const { showOptions,selectedOption } = this.state;
    return (
      <>
      {error &&
            <Typography className={classes.errorText} variant="caption" color="error"><Error />{" "}{errorText}</Typography>
            }
        <div className={cs({[classes.selectContainer]:true,[classes.errorBorder]:error})} 
        onClick={(event: any) => { this.handleShowOptions(event) }}>
       

          {isMulti && !isSearchAble && !showOptions && values && values.length === 0 &&
          <div className="icon"><ExpandMoreIcon /></div>
          }

          {/* {
            !_.isEmpty(values) &&
            <div className="icon"><CloseIcon/></div>
          } */}

          {isMulti && values && values.length > 0 &&
            <div className="chipInput">
              <div className="chipContainer">
                {
                  values.map((option: any) => {
                      return (
                        <span className={classes.customChip}>
                          <span className="chipLabel"> {option[`${labelKey}`]} </span>
                          <span
                            className="chipIcon"
                            onClick={() => this.props.onChange(option,name)}
                          >
                            {" "}
                            <CancelIcon />
                          </span>
                        </span>
                      );
                  })}
              </div>
            </div>
          }
          {/* {!isMulti && values &&
            <div className="singleSelectOption">
                     <span>
                        {//@ts-ignore
                          values[`${labelKey}`]
                        }
                      </span>
              
            </div>
          } */}


          { isMulti || isSearchAble &&
           <>
          <Grid container justify="flex-start" alignItems="center">
            <Grid item>
              <div className="search-btn">
              <img
                src="/assets/svg/userManagement/search-icon.svg"
                alt="search"
              />
            </div>
            </Grid>
            <Grid item xs={10}>
              <input type="text"
                onClick={(event: any) => { event.stopPropagation() }}
                onFocus={() => showAllOptionsOnFocus && this.getFilteredOptions()}
                onChange={(event: any) => { this.setState({inputValue:event.target.value},
                                                ()=>{this.getFilteredOptions()}); }}
                placeholder={values && !_.isEmpty(values) ? '' : placeholderText?placeholderText:'search'}
                value={this.state.inputValue}
                disabled={disableInput}
              />
            </Grid>
            </Grid>
            </>
            }



        </div>
        {
            showOptions &&
        <div className={classes.optionBox}>
         
            <div className="optionContainer">
              <div className="multiSelectOptions"
              >

                {
                  isDropdownSearch &&
                  <div className="search-btn">
                    <img
                      src="/assets/svg/userManagement/search-icon.svg"
                      alt="search"
                    />
                  </div>
                }
                {
                  isDropdownSearch &&
                  <Grid className="inputDropdown">
                    <input type="text"
                      ref={input => input && input.focus()}
                      onClick={(event: any) => { event.stopPropagation() }}
                      onChange={(event: any) => { this.setState({inputValue:event.target.value},
                        ()=>{this.getFilteredOptions()}); }}
                      placeholder={values && values.length > 0 ? '' : 'Add Client and user'}
                      value={this.state.inputValue}
                    />
                  </Grid>
                }
                <ClickAwayListener onClickAway={this.closeDropDown}>
                   {this.renderOptions()}
                </ClickAwayListener>
              </div>

            </div>
         
        </div>
         }
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATMultiSearch);
